// Generated by purs version 0.15.15
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_Regex from "../Data.String.Regex/index.js";
import * as Data_String_Regex_Flags from "../Data.String.Regex.Flags/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Ouroboros_Models_Brands_BatchID from "../Ouroboros.Models.Brands.BatchID/index.js";
import * as Ouroboros_Models_Brands_ClientID from "../Ouroboros.Models.Brands.ClientID/index.js";
import * as Ouroboros_Models_Brands_ClientName from "../Ouroboros.Models.Brands.ClientName/index.js";
import * as Ouroboros_Models_Brands_DocumentID from "../Ouroboros.Models.Brands.DocumentID/index.js";
import * as Ouroboros_Models_Brands_DocumentUploadFileName from "../Ouroboros.Models.Brands.DocumentUploadFileName/index.js";
import * as Ouroboros_Models_Brands_FileSizeBytes from "../Ouroboros.Models.Brands.FileSizeBytes/index.js";
import * as Ouroboros_Models_Brands_IsoTimestamp from "../Ouroboros.Models.Brands.IsoTimestamp/index.js";
import * as Ouroboros_Models_Brands_MimeType from "../Ouroboros.Models.Brands.MimeType/index.js";
import * as Ouroboros_Models_Brands_OrganizationID from "../Ouroboros.Models.Brands.OrganizationID/index.js";
import * as Ouroboros_Models_Brands_ProjectDocumentClassification from "../Ouroboros.Models.Brands.ProjectDocumentClassification/index.js";
import * as Ouroboros_Models_Brands_ProjectDocumentID from "../Ouroboros.Models.Brands.ProjectDocumentID/index.js";
import * as Ouroboros_Models_Brands_ProjectDocumentStatus from "../Ouroboros.Models.Brands.ProjectDocumentStatus/index.js";
import * as Ouroboros_Models_Brands_ProjectDocumentType from "../Ouroboros.Models.Brands.ProjectDocumentType/index.js";
import * as Ouroboros_Models_Brands_ProjectID from "../Ouroboros.Models.Brands.ProjectID/index.js";
import * as Ouroboros_Models_Brands_ProjectName from "../Ouroboros.Models.Brands.ProjectName/index.js";
import * as Ouroboros_Models_Brands_StorageURI from "../Ouroboros.Models.Brands.StorageURI/index.js";
import * as Ouroboros_Models_Brands_UploadURL from "../Ouroboros.Models.Brands.UploadURL/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var show = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Data_List_Types.showNonEmptyList(Foreign.showForeignError));
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var readRecord = /* #__PURE__ */ Simple_JSON.readRecord();
var readFieldsCons = /* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "items";
    }
});
var readFieldsCons1 = /* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "created_at";
    }
})(Ouroboros_Models_Brands_IsoTimestamp.readIsoTimestamp);
var readFieldsCons2 = /* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
});
var readRecord1 = /* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "batch_id";
    }
})(/* #__PURE__ */ Simple_JSON.readMaybe(Ouroboros_Models_Brands_BatchID.readBatchID))(/* #__PURE__ */ readFieldsCons1(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "document_type";
    }
})(Ouroboros_Models_Brands_ProjectDocumentType.readProjectDocumentType)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "file_size";
    }
})(Ouroboros_Models_Brands_FileSizeBytes.readFileSizeBytes)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "filename";
    }
})(Ouroboros_Models_Brands_DocumentUploadFileName.readDocumentUploadFileName)(/* #__PURE__ */ readFieldsCons2(Ouroboros_Models_Brands_ProjectDocumentID.readProjectDocumentID)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "last_processed_at";
    }
})(/* #__PURE__ */ Simple_JSON.readMaybe(Ouroboros_Models_Brands_IsoTimestamp.readIsoTimestamp))(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "mime_type";
    }
})(Ouroboros_Models_Brands_MimeType.readMimeType)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "project_id";
    }
})(Ouroboros_Models_Brands_ProjectID.readProjectID)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "source_document_ids";
    }
})(/* #__PURE__ */ Simple_JSON.readArray(Ouroboros_Models_Brands_DocumentID.readDocumentID))(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "status";
    }
})(Ouroboros_Models_Brands_ProjectDocumentStatus.readProjectDocumentStatus)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "storage_uri";
    }
})(Ouroboros_Models_Brands_StorageURI.readStorageURI)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "suggested_classification";
    }
})(Ouroboros_Models_Brands_ProjectDocumentClassification.readProjectDocumentClassification)(Simple_JSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()());
var readFieldsCons3 = /* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
});
var readFieldsCons4 = /* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "organization_id";
    }
})(Ouroboros_Models_Brands_OrganizationID.readOrganizationID);
var uuidPattern = "^(?:[0-9a-f]{32}|[0-9a-f]{8}-[0-9a-f]{4}-[1-7][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})$";
var readJson = function (dictReadForeign) {
    var read = Simple_JSON.read(dictReadForeign);
    return function (value) {
        return lmap(show)(read(value));
    };
};
var readJson1 = /* #__PURE__ */ readJson(/* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons(/* #__PURE__ */ Simple_JSON.readArray(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "document";
    }
})(readRecord1)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "upload_url";
    }
})(Ouroboros_Models_Brands_UploadURL.readUploadURL)(Simple_JSON.readFieldsNil)()())()())))(Simple_JSON.readFieldsNil)()()));
var readJson2 = /* #__PURE__ */ readJson(/* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons(/* #__PURE__ */ Simple_JSON.readArray(readRecord1))(Simple_JSON.readFieldsNil)()()));
var readJson3 = /* #__PURE__ */ readJson(/* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons(/* #__PURE__ */ Simple_JSON.readArray(/* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons1(/* #__PURE__ */ readFieldsCons2(Ouroboros_Models_Brands_ClientID.readClientID)(/* #__PURE__ */ readFieldsCons3(Ouroboros_Models_Brands_ClientName.readClientName)(/* #__PURE__ */ readFieldsCons4(Simple_JSON.readFieldsNil)()())()())()())()())))(Simple_JSON.readFieldsNil)()()));
var readJson4 = /* #__PURE__ */ readJson(/* #__PURE__ */ readRecord(/* #__PURE__ */ readFieldsCons(/* #__PURE__ */ Simple_JSON.readArray(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "client_id";
    }
})(/* #__PURE__ */ Simple_JSON.readMaybe(Ouroboros_Models_Brands_ClientID.readClientID))(/* #__PURE__ */ readFieldsCons1(/* #__PURE__ */ readFieldsCons2(Ouroboros_Models_Brands_ProjectID.readProjectID)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "last_updated_at";
    }
})(Ouroboros_Models_Brands_IsoTimestamp.readIsoTimestamp)(/* #__PURE__ */ readFieldsCons3(Ouroboros_Models_Brands_ProjectName.readProjectName)(/* #__PURE__ */ readFieldsCons4(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "updated_at";
    }
})(Ouroboros_Models_Brands_IsoTimestamp.readIsoTimestamp)(Simple_JSON.readFieldsNil)()())()())()())()())()())()())()())))(Simple_JSON.readFieldsNil)()()));
var isoDatePattern = "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(?:\\.\\d{1,9})?Z$";
var isNonEmpty = function (value) {
    return value !== "";
};
var isMimeType = function (value) {
    var testMime = (function () {
        var v = Data_String_Regex.regex("/")(Data_String_Regex_Flags.ignoreCase);
        if (v instanceof Data_Either.Left) {
            return Data_Function["const"](false);
        };
        if (v instanceof Data_Either.Right) {
            return Data_String_Regex.test(v.value0);
        };
        throw new Error("Failed pattern match at Ouroboros.Models.Clients.ClientProject (line 93, column 14 - line 95, column 36): " + [ v.constructor.name ]);
    })();
    return isNonEmpty(value) && testMime(value);
};
var isMatch = function (pattern) {
    return function (value) {
        var v = Data_String_Regex.regex(pattern)(Data_String_Regex_Flags.ignoreCase);
        if (v instanceof Data_Either.Left) {
            return false;
        };
        if (v instanceof Data_Either.Right) {
            return Data_String_Regex.test(v.value0)(value);
        };
        throw new Error("Failed pattern match at Ouroboros.Models.Clients.ClientProject (line 74, column 3 - line 76, column 42): " + [ v.constructor.name ]);
    };
};
var isUuid = function (value) {
    return isMatch(uuidPattern)(value);
};
var isIsoDate = function (value) {
    return isMatch(isoDatePattern)(value);
};
var isDocumentStatus = function (value) {
    return value === "Pending" || (value === "Processing" || (value === "Completed" || value === "Failed"));
};
var validateProjectDocument = function (doc) {
    return isUuid(Ouroboros_Models_Brands_ProjectDocumentID.unwrap(doc.id)) && (isUuid(Ouroboros_Models_Brands_ProjectID.unwrap(doc.project_id)) && (isNonEmpty(Ouroboros_Models_Brands_DocumentUploadFileName.unwrap(doc.filename)) && (isMimeType(Ouroboros_Models_Brands_MimeType.unwrap(doc.mime_type)) && (Ouroboros_Models_Brands_FileSizeBytes.unwrap(doc.file_size) >= 0.0 && (isNonEmpty(Ouroboros_Models_Brands_StorageURI.unwrap(doc.storage_uri)) && (isDocumentStatus(Ouroboros_Models_Brands_ProjectDocumentStatus.unwrap(doc.status)) && (isIsoDate(Ouroboros_Models_Brands_IsoTimestamp.unwrap(doc.created_at)) && (isNonEmpty(Ouroboros_Models_Brands_ProjectDocumentType.unwrap(doc.document_type)) && (isNonEmpty(Ouroboros_Models_Brands_ProjectDocumentClassification.unwrap(doc.suggested_classification)) && ((function () {
        if (doc.last_processed_at instanceof Data_Maybe.Nothing) {
            return true;
        };
        if (doc.last_processed_at instanceof Data_Maybe.Just) {
            return isIsoDate(Ouroboros_Models_Brands_IsoTimestamp.unwrap(doc.last_processed_at.value0));
        };
        throw new Error("Failed pattern match at Ouroboros.Models.Clients.ClientProject (line 235, column 8 - line 237, column 60): " + [ doc.last_processed_at.constructor.name ]);
    })() && ((function () {
        if (doc.batch_id instanceof Data_Maybe.Nothing) {
            return true;
        };
        if (doc.batch_id instanceof Data_Maybe.Just) {
            return isUuid(Ouroboros_Models_Brands_BatchID.unwrap(doc.batch_id.value0));
        };
        throw new Error("Failed pattern match at Ouroboros.Models.Clients.ClientProject (line 238, column 8 - line 240, column 56): " + [ doc.batch_id.constructor.name ]);
    })() && Data_Array.all(function ($210) {
        return isUuid(Ouroboros_Models_Brands_DocumentID.unwrap($210));
    })(doc.source_document_ids))))))))))));
};
var validatePresignedUpload = function (upload) {
    return validateProjectDocument(upload.document) && isNonEmpty(Ouroboros_Models_Brands_UploadURL.unwrap(upload.upload_url));
};
var failWith = function (message) {
    return new Data_Either.Left(message);
};
var decodeProjectDocumentPresignResponse = function (value) {
    return bind(readJson1(value))(function (decoded) {
        var $204 = Data_Array.all(validatePresignedUpload)(decoded.items);
        if ($204) {
            return new Data_Either.Right(decoded);
        };
        return failWith("Invalid presign payload");
    });
};
var decodeProjectDocumentListResponse = function (value) {
    return bind(readJson2(value))(function (decoded) {
        var $205 = Data_Array.all(validateProjectDocument)(decoded.items);
        if ($205) {
            return new Data_Either.Right(decoded);
        };
        return failWith("Invalid project document payload");
    });
};
var constNilUuid = "00000000-0000-0000-0000-000000000000";
var isOrgId = function (value) {
    return value === constNilUuid || isUuid(value);
};
var validateClient = function (client) {
    return isUuid(Ouroboros_Models_Brands_ClientID.unwrap(client.id)) && (isOrgId(Ouroboros_Models_Brands_OrganizationID.unwrap(client.organization_id)) && (isNonEmpty(Ouroboros_Models_Brands_ClientName.unwrap(client.name)) && isIsoDate(Ouroboros_Models_Brands_IsoTimestamp.unwrap(client.created_at))));
};
var decodeClientListResponse = function (value) {
    return bind(readJson3(value))(function (decoded) {
        var $206 = Data_Array.all(validateClient)(decoded.items);
        if ($206) {
            return new Data_Either.Right(decoded);
        };
        return failWith("Invalid client list payload");
    });
};
var validateProject = function (project) {
    return isUuid(Ouroboros_Models_Brands_ProjectID.unwrap(project.id)) && (isOrgId(Ouroboros_Models_Brands_OrganizationID.unwrap(project.organization_id)) && (isNonEmpty(Ouroboros_Models_Brands_ProjectName.unwrap(project.name)) && (isIsoDate(Ouroboros_Models_Brands_IsoTimestamp.unwrap(project.last_updated_at)) && (isIsoDate(Ouroboros_Models_Brands_IsoTimestamp.unwrap(project.created_at)) && (isIsoDate(Ouroboros_Models_Brands_IsoTimestamp.unwrap(project.updated_at)) && (function () {
        if (project.client_id instanceof Data_Maybe.Nothing) {
            return true;
        };
        if (project.client_id instanceof Data_Maybe.Just) {
            return isUuid(Ouroboros_Models_Brands_ClientID.unwrap(project.client_id.value0));
        };
        throw new Error("Failed pattern match at Ouroboros.Models.Clients.ClientProject (line 219, column 8 - line 221, column 59): " + [ project.client_id.constructor.name ]);
    })())))));
};
var decodeProjectListResponse = function (value) {
    return bind(readJson4(value))(function (decoded) {
        var $209 = Data_Array.all(validateProject)(decoded.items);
        if ($209) {
            return new Data_Either.Right(decoded);
        };
        return failWith("Invalid project list payload");
    });
};
export {
    decodeClientListResponse,
    decodeProjectListResponse,
    decodeProjectDocumentListResponse,
    decodeProjectDocumentPresignResponse
};
//# sourceMappingURL=index.js.map
